
/**
 * Types d'événements qui peuvent déclencher l'envoi d'un mail
 */
export const EVENT_TYPES = {
  REGISTRATION: 'registration',
  BEFORE_TRAINING: 'before_training',
  TRAINING_START: 'training_start',
  TRAINING_END: 'training_end',
  AFTER_TRAINING: 'after_training',
  MANUAL: 'manual'
};

/**
 * Structure d'une notification par mail
 */
export const DEFAULT_EMAIL_TEMPLATE = {
  id: '',
  name: '',
  subject: '',
  content: '',
  type: 'session',
  eventType: '',
  daysOffset: 0,
  isActive: true,
  createdAt: null,
  updatedAt: null
};

